import { useContext, useState } from "react";
import { Col, Row, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { userPath, userPublicationsPath } from "../../routes/routes";
import {
  getProfileImageFromUser,
  normalizeImageSrc,
} from "../../../infrastructure/utils/normalizeImageSrc";
import { UserDataContext } from "../../contexts/Contexts";

export const AvatarLayout = ({ userData, photo }) => {
  const [loading, setLoading] = useState(true);
  const { userData: currentUserData } = useContext(UserDataContext);
  const profileUserData = {
    ...userData,
    idUsuario:
      userData?.idUsuario ??
      userData?.IdUsuario ??
      userData?.idAmigo ??
      userData?.IdAmigo ??
      userData?.id ??
      userData?.userId ??
      userData?.idUsuarioOrigen,
  };

  const handleImageLoad = () => {
    setLoading(false);
  };

  const handleImageError = () => {
    setLoading(false);
  };

  const spinnerIcon = (
    <LoadingOutlined style={{ fontSize: 24, color: "#F18B6F" }} spin />
  );
  const fallbackAvatar = "/img/icons/UserFalse.svg";
  const avatarSrc =
    userData?.estatus === "E"
      ? "/img/icons/UserDelete.png"
      : normalizeImageSrc(photo) ||
        getProfileImageFromUser(userData) ||
        fallbackAvatar;
  const isCurrentUser =
    String(profileUserData?.idUsuario ?? "") ===
    String(currentUserData?.idUsuario ?? "");
  const profilePath = isCurrentUser ? userPublicationsPath : userPath;

  const content = (
    <Row align="top" wrap={false}>
      <Col className="center-elements">
        <div
          className="center-elements"
          style={{
            width: 45,
            minWidth: 45,
            maxWidth: 45,
            height: 45,
            minHeight: 45,
            maxHeight: 45,
            aspectRatio: "1 / 1",
            flex: "0 0 45px",
            borderRadius: "50%",
            overflow: "hidden",
            backgroundColor: "#f3f3f3",
            margin: "0 5px 15px 0",
          }}
        >
          <Spin
            indicator={spinnerIcon}
            spinning={loading}
            style={{ width: "100%", height: "100%" }}
          >
            <img
              src={avatarSrc}
              alt="profile-pic"
              className="profile-img-sidebar"
              onLoad={handleImageLoad}
              onError={(event) => {
                handleImageError();
                event.currentTarget.onerror = null;
                event.currentTarget.src = fallbackAvatar;
              }}
              style={{
                display: loading ? "none" : "block",
                width: "100%",
                height: "100%",
                minWidth: "100%",
                maxWidth: "100%",
                minHeight: "100%",
                maxHeight: "100%",
                aspectRatio: "1 / 1",
                borderRadius: "50%",
                objectFit: "cover",
                objectPosition: "center",
              }}
            />
          </Spin>
        </div>
      </Col>
      <Col>
        <Row>
          {userData?.apellidos ? (
            <span className="user-name">
              {`${userData.nombres} ${userData.apellidos}`}
            </span>
          ) : (
            <span className="user-name">
              {userData?.nombre || userData?.nombres}
            </span>
          )}
        </Row>
        <Row style={{ lineHeight: "15px" }}>
          <span className="user-nick">{userData?.nickName}</span>
        </Row>
      </Col>
    </Row>
  );

  return userData?.estatus === "E" || !profileUserData?.idUsuario ? (
    content
  ) : (
    <Link to={profilePath} state={profileUserData}>
      {content}
    </Link>
  );
};
